import { Injectable } from "@angular/core";
import { RestService } from "../../../services/rest.service";
import { OrganisationUser } from '../models/organisation-user.model';
import { CreateOrganisationUserDto } from "../dto/create-organisation-user.dto";
import { UpdateZohoPaymentAccountResponse } from "../interface/zoho-deposit-account.interface";

@Injectable({
  providedIn: 'root'
})
export class MasterOrganisationUserService {

  static readonly ApiUrl = 'master/organisation-user/'

  constructor(private restService: RestService,
  ) {
  }


  async create(orgId: string, addUserDto: CreateOrganisationUserDto) {
    return this.restService.send<OrganisationUser[]>({
      url: MasterOrganisationUserService.ApiUrl + 'create/' + orgId,
      body: addUserDto,
      method: 'POST',
    })
  }

  async getOrganisationUsers(orgId: string) {
    return (await this.restService.send<OrganisationUser[]>({
      url: MasterOrganisationUserService.ApiUrl + orgId,
      method: 'GET',
    })).data
  }

  /**
   * Set or clear Zoho Books payment account for a master org user (enables/disables Cash).
   * Pass null to clear. When setting, backend validates against Zoho and returns account details.
   */
  async updateZohoPaymentAccount(
    orgUserId: string,
    zohoPaymentAccountId: string | null,
  ): Promise<UpdateZohoPaymentAccountResponse> {
    return (await this.restService.send<UpdateZohoPaymentAccountResponse>({
      url: MasterOrganisationUserService.ApiUrl + orgUserId + '/zoho-payment-account',
      method: 'PUT',
      body: { zohoPaymentAccountId },
      throwError: true,
    })).data;
  }

}
